import { useLocation } from 'react-router-dom';

import Button from '@/components/common/Button';

const InternalError = () => {
  const { state } = useLocation();

  const onClickGoHome = () => {
    location.href = location.origin;
  };

  const onClickReload = () => {
    location.href = state?.returnUrl || location.origin;
  };

  return (
    <>
      <h3 className="screen_out">본문</h3>
      <div className="wallet_empty">
        <div className="inner_wallet_empty inner_wallet_empty1">
          <div className="wrap_icon">
            <strong className="ico_wallet ico_exclam_60">알림</strong>
          </div>
          <strong className="tit_empty">페이지를 표시할 수 없습니다</strong>
          <p className="desc_empty">
            일시적인 시스템 오류로 인해, 페이지를 표시할 수 없습니다. <br />
            잠시 후 다시 시도해 주세요.
          </p>
          <div className="group_btn">
            <Button size="l" variant="primary" onClick={onClickReload}>
              <span className="txt_btn">새로고침</span>
            </Button>
            <Button size="l" variant="highlight" onClick={onClickGoHome}>
              <span className="txt_btn">홈으로 가기</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InternalError;
